import styled from 'styled-components';

const FAQ = styled.div`
    background: #b4b4b4;
    padding: 12px;
    // border-radius: 20px;
    text-align: center;
    color: #000;
    font-size: 20px;
    font-weight: bold;
`;

export default FAQ;



// WEBPACK FOOTER //
// ./app/containers/Login/components/FAQ/index.js